'use client';

import ServiceLayout from '@/components/layout/service/ServiceLayout';

interface MagazineLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: MagazineLayoutProps) {
    return <ServiceLayout>{children}</ServiceLayout>;
}
